import { CHROME_WEB_STORE_URL } from '@common-config/constants';
import { Chrome } from 'lucide-react';
import { CSSProperties } from 'react';

interface BrowserExtensionSectionProps {
  styles: Record<string, CSSProperties>;
}

export const BrowserExtensionSection = ({ styles }: BrowserExtensionSectionProps) => (
  <div style={styles.browserOption}>
    <div style={styles.optionTitle}>
      <Chrome size={20} />
      Browser Extension
    </div>
    <div style={{ ...styles.featureList, color: '#0369a1' }}>
      <div style={styles.featureItem}>
        <svg style={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        Free to use
      </div>
      <div style={styles.featureItem}>
        <svg style={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        Easy installation
      </div>
      <div style={styles.featureItem}>
        <svg style={styles.checkIcon} viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
        </svg>
        Browser must stay open
      </div>
    </div>
    <button
      style={styles.browserButton}
      onClick={() => window.open(CHROME_WEB_STORE_URL, '_blank')}
    >
      <Chrome size={16} />
      Install Extension
    </button>
  </div>
); 